//import { ReactComponent as ProjectsIcon } from "./projects.svg";

const iconSize = "w-5 h-5";

export const Icons = {
  Camera: ({ className }) => (
    <svg
      className={className || iconSize}
      fill="none"
      stroke="currentColor"
      viewBox="0 0 24 24"
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
        d="M3 8a2 2 0 012-2h2l1.5-2A2 2 0 0110.118 3h3.764a2 2 0 011.618.882L17 6h2a2 2 0 012 2v9a2 2 0 01-2 2H5a2 2 0 01-2-2V8z"
      />
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
        d="M15 13a3 3 0 11-6 0 3 3 0 016 0z"
      />
    </svg>
  ),
  Dashboard: ({ className }) => (
    <svg
      className={className || iconSize}
      fill="none"
      stroke="currentColor"
      viewBox="0 0 24 24"
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
        d="M3 7v10a2 2 0 002 2h14a2 2 0 002-2V9a2 2 0 00-2-2H5a2 2 0 00-2-2z"
      />
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
        d="M8 5a2 2 0 012-2h4a2 2 0 012 2v6H8V5z"
      />
    </svg>
  ),

  //Projects: ({ className }) => <ProjectsIcon className={className || iconSize} />,

  Projects: ({ className }) => (
    <svg
      className={className || iconSize}
      fill="none"
      stroke="currentColor"
      viewBox="0 0 24 24"
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
        d="M3 7v10a2 2 0 002 2h14a2 2 0 002-2V9a2 2 0 00-2-2H5a2 2 0 00-2-2z"
      />
    </svg>
  ),
  Estimate: ({ className }) => (
    <svg
      className={className || iconSize}
      fill="none"
      stroke="currentColor"
      viewBox="0 0 24 24"
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
        d="M9 7h6m0 10v-3m-3 3h.01M9 17h.01M9 14h.01M12 14h.01M15 11h.01M12 11h.01M9 11h.01M7 21h10a2 2 0 002-2V5a2 2 0 00-2-2H7a2 2 0 00-2 2v14a2 2 0 002 2z"
      />
    </svg>
  ),
  BidComparison: ({ className }) => (
    <svg
      className={className || iconSize}
      fill="none"
      stroke="currentColor"
      viewBox="0 0 24 24"
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
        d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z"
      />
    </svg>
  ),
  Logout: ({ className }) => (
    <svg
      className={className || iconSize}
      fill="none"
      stroke="currentColor"
      viewBox="0 0 24 24"
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
        d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1"
      />
    </svg>
  ),
  Menu: ({ className }) => (
    <svg
      className={className || iconSize}
      fill="none"
      stroke="currentColor"
      viewBox="0 0 24 24"
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
        d="M4 6h16M4 12h16M4 18h16"
      />
    </svg>
  ),
  Close: ({ className }) => (
    <svg
      className={className || iconSize}
      fill="none"
      stroke="currentColor"
      viewBox="0 0 24 24"
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
        d="M6 18L18 6M6 6l12 12"
      />
    </svg>
  ),
  Notifications: ({ className }) => (
    <svg
      className={className || iconSize}
      fill="none"
      stroke="currentColor"
      viewBox="0 0 24 24"
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
        d="M15 17h5l-1.405-1.405A2.032 2.032 0 0118 14.158V11a6.002 6.002 0 00-4-5.659V4a2 2 0 10-4 0v1.341C7.67 6.165 6 8.388 6 11v3.159c0 .538-.214 1.055-.595 1.436L4 17h5m6 0v1a3 3 0 11-6 0v-1m6 0H9"
      />
    </svg>
  ),
  ReceiptCapture: ({ className }) => (
    <svg
      className={className || iconSize}
      fill="none"
      stroke="currentColor"
      viewBox="0 0 24 24"
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
        d="M9 17v-2a1 1 0 011-1h4a1 1 0 011 1v2m4-10h-1.586A1 1 0 0116 6.414l-1-1A1 1 0 0014.586 5H9.414a1 1 0 00-.707.293l-1 1A1 1 0 017.586 7H6a2 2 0 00-2 2v9a2 2 0 002 2h12a2 2 0 002-2V9a2 2 0 00-2-2z"
      />
    </svg>
  ),
  Scheduling: ({ className }) => (
    <svg
      className={className || iconSize}
      fill="none"
      stroke="currentColor"
      viewBox="0 0 24 24"
    >
      <rect
        x="3"
        y="4"
        width="18"
        height="18"
        rx="2"
        ry="2"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <line
        x1="16"
        y1="2"
        x2="16"
        y2="6"
        strokeWidth={2}
        strokeLinecap="round"
      />
      <line x1="8" y1="2" x2="8" y2="6" strokeWidth={2} strokeLinecap="round" />
      <line
        x1="3"
        y1="10"
        x2="21"
        y2="10"
        strokeWidth={2}
        strokeLinecap="round"
      />
    </svg>
  ),

  ToDo: ({ className }) => (
    <svg
      className={className || iconSize}
      fill="none"
      stroke="currentColor"
      viewBox="0 0 24 24"
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
        d="M9 5H7a2 2 0 00-2 2v10a2 2 0 002 2h8a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2m-6 9l2 2 4-4"
      />
    </svg>
  ),
  Receipts: ({ className }) => (
    <svg
      className={className || iconSize}
      fill="none"
      stroke="currentColor"
      viewBox="0 0 24 24"
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
        d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
      />
    </svg>
  ),
  Gallery: ({ className }) => (
    <svg
      className={className || iconSize}
      fill="none"
      stroke="currentColor"
      viewBox="0 0 24 24"
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
        d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z"
      />
    </svg>
  ),
  Contacts: ({ className }) => (
    <svg
      className={className || iconSize}
      fill="none"
      stroke="currentColor"
      viewBox="0 0 24 24"
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
        d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z"
      />
    </svg>
  ),
  CostCatalog: ({ className }) => (
    <svg
      className={className || iconSize}
      fill="none"
      stroke="currentColor"
      viewBox="0 0 24 24"
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
        d="M12 6.253v13m0-13C10.832 5.477 9.246 5 7.5 5S4.168 5.477 3 6.253v13C4.168 18.477 5.754 18 7.5 18s3.332.477 4.5 1.253m0-13C13.168 5.477 14.754 5 16.5 5c1.747 0 3.332.477 4.5 1.253v13C19.832 18.477 18.247 18 16.5 18c-1.746 0-3.332.477-4.5 1.253"
      />
    </svg>
  ),
  Proposal: ({ className }) => (
    <svg
      className={className || iconSize}
      fill="none"
      stroke="currentColor"
      viewBox="0 0 24 24"
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
        d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
      />
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
        d="M15 2v5a2 2 0 002 2h5"
      />
    </svg>
  ),
};

// Navigation items with icons and keywords
export const navItems = [
  {
    name: "Dashboard",
    path: "/Dashboard",
    icon: Icons.Dashboard,
    keywords: ["dashboard", "home", "overview", "main"],
  },
  // {
  //   name: "Projects",
  //   path: "/ProjectList",
  //   icon: Icons.Projects,
  //   keywords: ["projects", "list", "manage", "work"],
  // },
  {
    name: "Projects",
    icon: Icons.Projects,
    keywords: ["build", "project", "site"],
    children: [
      {
        name: "Projects",
        path: "/ProjectList",
      },
      {
        name: "To Dashboard",
        path: "/Dashboard",
      },
    ],
  },
  {
    name: "Estimate",
    path: "/estimate-new",
    icon: Icons.Estimate,
    keywords: ["Estimate", "calculate", "cost", "price", "quote"],
  },
  {
    name: "Cost Catalog",
    path: "/cost-catalog",
    icon: Icons.CostCatalog,
    keywords: ["cost", "catalog", "pricing", "items", "materials"],
  },
  {
    name: "Bid Comparison",
    path: "/Bid-Comparison",
    icon: Icons.BidComparison,
    keywords: ["bid", "comparison", "compare", "analysis", "chart"],
  },
  {
    name: "Receipt Capture",
    path: "/Receipt-Capture",
    icon: Icons.ReceiptCapture,
    keywords: ["receipt", "camera", "scan", "upload", "capture"],
  },
  {
    name: "Receipts",
    path: "/Receipts",
    icon: Icons.Receipts,
    keywords: ["Receipts", "list", "view", "manage"],
  },
  {
    name: "Scheduling",
    path: "/Scheduling",
    icon: Icons.Scheduling,
    keywords: ["calendar", "Scheduling", "events", "dates"],
  },
  {
    name: "Tasks",
    path: "/Tasks",
    icon: Icons.ToDo,
    keywords: ["tasks", "checklist", "To-Do", "reminders"],
  },
  {
    name: "Contacts",
    path: "/contacts",
    icon: Icons.Contacts,
    keywords: ["contacts", "people", "clients", "contractors", "business"],
  },
  {
    name: "Gallery",
    path: "/gallery",
    icon: Icons.Gallery,
    keywords: ["gallery", "photos", "images", "pictures", "media"],
  },
  {
    name: "Camera Test",
    path: "/camera-test-2",
    icon: Icons.Camera,
    keywords: ["camera", "photo", "capture", "test"],
  },
  {
    name: "Notifications",
    path: "/Notifications",
    icon: Icons.Notifications,
    keywords: ["Notifications", "alerts", "messages", "updates", "reminders"],
  },
  {
    name: "CRM",
    path: "/crm-new",
    icon: Icons.Gallery,
    keywords: ["CRM"],
  },
  {
    name: "Proposals",
    path: "/proposals",
    icon: Icons.Proposal,
    keywords: ["proposal", "pdf", "quote", "estimate", "share", "document"],
  },
];
